import * as Yup from 'yup';
import { Navigate, useRoutes,useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState,useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useSearchParams, useRouter } from 'src/routes/hooks';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';

// auth
import { useAuthContext } from 'src/auth/hooks';

import FormProvider, { RHFTextField } from 'src/components/hook-form';
import httpCommon from 'src/http-common';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// ----------------------------------------------------------------------

export default function JwtLoginView() {
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
    
   const id22 = queryParams.get('site_cd');

  const [drpSata, setDrpData] = useState([]);

  const [selectedValue, setSelectedValue] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState(drpSata);

  const { login } = useAuthContext();

  const router = useRouter();

  const [errorMsg, setErrorMsg] = useState('');

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo');

  const LoginSchema = Yup.object().shape({
    id: Yup.string().required('Staff ID is required'),
    // hospital: Yup.string().required('Hospital is required'),
    
  });
  
  useEffect(() => {
    fetchFilterDropdown();
  }, []);

  const fetchFilterDropdown = async () => {
    try {
      const response = await httpCommon.get("/get_sitecode.php");
       
      if(response.data.status === 'SUCCESS'){
        setDrpData(response.data.data);
      }
      
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const selectedOption = drpSata.find(option => option.site_cd === id22);
    if (selectedOption) {
      setSelectedValue(selectedOption);
      
    }
  }, [id22, drpSata]);
  const methods = useForm({
    resolver: yupResolver(LoginSchema),
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data,) => {
  
    const { id, hospital } = data;
  
    try {
      if(id !== '' && selectedValue.site_cd !== ''){
        localStorage.setItem('QRId', id);
        localStorage.setItem('Hsp', selectedValue.site_cd);
        localStorage.setItem('HspName',selectedValue.site_name);
        router.push( PATH_AFTER_LOGIN);
      }
       
    } catch (error) {
      console.error(error);
      // reset();
      setErrorMsg(typeof error === 'string' ? error : "Hospital is required");
  
    }
  });

  const renderHead = (
    <Stack spacing={2} sx={{ mb: 5 }} className='LoginImg'>
      <Typography variant="h4">Sign in to CMMS Web Work</Typography>

    </Stack>
  );

  const renderForm = (
    <Stack spacing={2.5}>
      {!!errorMsg && <Alert severity="error">{errorMsg}</Alert>}
      
      <RHFTextField name="id" label="Staff ID" />

      <Autocomplete
        value={selectedValue}
        onChange={(event, newValue) => {
          setSelectedValue(newValue); 
          setErrorMsg('');
        }}
        // options={drpSata} 
        options={drpSata} 
        getOptionLabel={(option) => `${option.site_cd} : ${option.site_name} `}
        getOptionValue={(option) => option.site_cd} 
        renderInput={(params) => (
          <TextField
            {...params}
            label="Hospital"
            variant="outlined"
          />
        )}
      />
      <LoadingButton
        fullWidth
        color="inherit"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitting}
      >
        Login
      </LoadingButton>
    </Stack>
  );
  return (
    

    <>
    <FormProvider methods={methods} onSubmit={onSubmit}>
      {renderHead}

   {renderForm}
    </FormProvider>
  
    </>
  );
}
